import { Alert, AlertDescription, AlertTitle } from '@playbooks/ui/components/alert'
import { cn } from '@playbooks/ui/lib/utils'
import WarningCircleIcon from './ui/icons/WarningCircleIcon'
import { useTranslation } from '../contexts/localization/Localization'

export default function NoSectionsAlert() {
  const { text } = useTranslation()

  return (
    <div
      className={cn(
        'flex items-center justify-center self-start mt-10 w-(--slide-width) px-4',
        'group-data-[view=funnel]:px-0',
      )}
    >
      <Alert className="w-(--slide-width)">
        <WarningCircleIcon />
        <AlertTitle>{text('noSectionsAdded')}</AlertTitle>
        <AlertDescription>{text('addSectionsText')}</AlertDescription>
      </Alert>
    </div>
  )
}
